export default {
  acab: 'ACAB',
  actions: 'Aktionen',
  addProduct: 'Produkt hinzufügen',
  arcPosition: 'ARC position',
  businessId: 'Geschäfts ID',
  businessPhone: 'Geschäftstelefon',
  cancel: 'Abbrechen',
  client: 'Klientin',
  clientReference: 'Kundenreferenz',
  clients: 'Kunden',
  clientSuccessfullyCreated: 'Client erfolgreich erstellt',
  clv: 'CLV',
  codeLab: 'Code Lab',
  colimptexCode: 'Colimptex code',
  color: 'Farbe',
  colors: 'Farben',
  colorSuccessfullyCreated: 'Farbe erfolgreich erstellt',
  colorSuccessfullyUpdated: 'Farbe erfolgreich aktualisiert',
  composition: 'Komposition',
  contactPerson: 'Kontakt',
  container: 'Container',
  containers: 'Behälter',
  containerSuccessfullyCreated: 'Container erfolgreich erstellt',
  containerSuccessfullyUpdated: 'Container erfolgreich aktualisiert',
  createClient: 'Client erstellen',
  createColor: 'Farbe erstellen',
  createContainerType: 'Containertyp erstellen',
  createOrderDetail: 'Bestelldetails erstellen',
  createOrder: 'Bestellung erstellen',
  createProduct: 'Produkt erstellen',
  createPurchase: 'Erstellen eines Kaufs',
  createPurchaseDetail: 'Erstellen von Einkaufsdetails',
  createSeller: 'Verkäufer erstellen',
  createSupplier: 'Lieferanten erstellen',
  created: 'erfolgreich erstellt',
  crf: 'CRF',
  csf: 'CSF',
  currency: 'Währung',
  deleteClient: 'Client löschen',
  deletePurchase: 'Kauf löschen',
  doYouWantToDeleteThisClient: 'Möchten Sie diesen Client wirklich löschen?',
  doYouWantToDeleteThisColor: 'Möchten Sie diese Farbe wirklich löschen?',
  doYouWantToDeleteThisContainer: 'Möchten Sie diesen Container wirklich löschen?',
  doYouWantToDeleteThisProduct: 'Möchten Sie dieses Produkt wirklich löschen?',
  doYouWantToDeleteThisPurchase: 'Möchten Sie diesen Kauf wirklich löschen?',
  doYouWantToDeleteThisSeller: 'Möchten Sie diesen Verkäufer wirklich löschen?',
  doYouWantToDeleteThisSupplier: 'Möchten Sie diesen Lieferanten wirklich löschen?',
  editAddedProduct: 'Bearbeitetes Produkt bearbeiten',
  editClient: 'Bearbeiten des Clients',
  editColor: 'Farbe bearbeiten',
  editContainer: 'Container bearbeiten',
  editOrderDetail: 'Auftragsdetails bearbeiten',
  editOrder: 'Bearbeitungsreihenfolge',
  editProduct: 'Bearbeiten des Produkts',
  editProvider: 'Edit-Anbieter',
  editPurchase: 'Kauf bearbeiten',
  editSeller: 'Bearbeiten des Verkäufers',
  editSupplier: 'Lieferanten bearbeiten',
  email: 'Email',
  enterDescription: 'Geben Sie eine Beschreibung des Benutzers ein',
  factory: 'Fabrik',
  fca: 'FCA',
  fiber: 'Ballaststoff',
  finalKilogramsQuantity: 'Endmenge in Kilogramm',
  finalMetersQuantity: 'Endmenge in Metern',
  finished: 'Fertig',
  hs: 'HS',
  iva: 'IVA',
  key: 'Schlüssel',
  kilogramsMaximumCapacity: 'Maximale Kapazität in Kilogramm',
  label: 'Etikette',
  language: 'Sprache',
  loading: 'Laden...',
  metersKilogramsQuantity: 'm/kg menge',
  mt3: 'm3',
  mustChargeBeforeCreatingItems: 'Muss vor dem Erstellen von Artikeln aufgeladen werden',
  name: 'Namen',
  newClient: 'Neuer Kunde',
  newColor: 'Neue Farbe',
  newContainer: 'Neuer Container',
  newOrderDetail: 'Neue Auftragsdetails',
  newOrder: 'Neue Ordnung',
  newProduct: 'Neues Produkt',
  newProvider: 'Neuer Anbieter',
  newPurchase: 'Neuer Einkauf',
  newSeller: 'Neuer Verkäufer',
  newSupplier: 'Neuer Lieferant',
  nit: 'Identifikationsnummer',
  noElementsRegistered: 'Keine Elemente registriert',
  onlyNumbersAllowed: 'Nur Zahlen erlaubt',
  paint: 'Farbe',
  performance: 'Performance',
  phone: 'Telefon',
  portOccupation: 'Hafenbesetzung',
  print: 'Drucken',
  productionDate: 'Produktionsdatum',
  product: 'Produkt',
  products: 'Produkte',
  productSuccessfullyCreated: 'Produkt erfolgreich erstellt',
  productSuccessfullyUpdated: 'Produkt erfolgreich aktualisiert',
  profileImagePath: 'Profilbild-URL',
  psv: 'PSV',
  purchaseSuccessfullyCreated: 'Kauf erfolgreich erstellt',
  purchaseSuccessfullyUpdated: 'Kauf erfolgreich aktualisiert',
  pvp: 'PVP',
  referenceInChina: 'Referenz in China',
  rgb: 'RGB',
  requiredAmount: 'Erforderliche Menge',
  requirement: 'Anforderung',
  save: 'Speichern',
  search: 'Suche',
  seller: 'Verkäuferin',
  sellers: 'Verkäuferinnen',
  sellerSuccessfullyCreated: 'Verkäufer erfolgreich erstellt',
  sellerSuccessfullyUpdated: 'Verkäufer erfolgreich aktualisiert',
  shippingDate: 'Versanddatum',
  shortName: 'Kurzer Name',
  sku: 'SKU',
  subInvoice: 'Unterrechnung',
  sublimation: 'Sublimation',
  supplier: 'Lieferant',
  suppliers: 'Lieferanten',
  supplierSuccessfullyCreated: 'Lieferant erfolgreich erstellt',
  supplierSuccessfullyUpdated: 'Lieferant erfolgreich aktualisiert',
  taxesRefund: 'Steuern erstatten',
  totalAmount: 'Gesamtmenge',
  trm: 'TRM',
  typeOfContainer: 'Art des Behälters',
  updated: 'erfolgreich aktualisiert',
  unitMeasure: 'Maßeinheit',
  viewClient: 'Client anzeigen',
  weight: 'Gewicht',
  wide: 'Breit',
  withholdingTax: 'Quellensteuer'
}
